import type { ObjectDirective } from 'vue'
import autosize from 'autosize'

const directive: ObjectDirective<HTMLElement> = {
  mounted (el, binding) {
    if (binding.value && el.tagName === 'TEXTAREA') {
      autosize(el as HTMLTextAreaElement)
    }
  },

  updated (el, binding) {
    if (binding.value && el.tagName === 'TEXTAREA') {
      autosize.update(el as HTMLTextAreaElement)
    }
  },

  unmounted (el) {
    autosize.destroy(el as HTMLTextAreaElement)
  },
}

export default directive
